"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var SceProperties_1 = require("./SceProperties");
var ComputeVariables_1 = require("./computeType/ComputeVariables");
var Field_1 = require("../constants/Field");
var Types_1 = require("../api/Types");
var Draft_1 = require("./drafts/Draft");
var Objects_1 = require("../api/Objects");
var ModelConstants_1 = require("../constants/ModelConstants");
var lodash_1 = require("lodash");
var Instance_1 = require("../api/Instance");
var DeepCopy_1 = require("./common/lib/DeepCopy");
var MappingModel_1 = require("./mapping/MappingModel");
var DataItem_1 = require("./common/base/DataItem");
var DataType_1 = require("./common/base/DataType");
var ComputeFunction_1 = require("./computeType/ComputeFunction");
var SceCompressedModel_1 = require("./SceCompressedModel/SceCompressedModel");
var EngineeringModel_1 = require("../api/enggModel/EngineeringModel");
var uuid_1 = require("uuid");
var ModelBase_1 = require("./ModelBase");
var ObjectType_1 = require("./objects/ObjectType");
var SceInstance_1 = require("../typeServices/instanceService/SceInstance");
var SceModel = /** @class */ (function () {
    function SceModel() {
        this._objectsApi = new Objects_1.Objects();
        this._enggModelApi = new EngineeringModel_1.EngineeringModel();
    }
    SceModel.fromJson = function (json, isInstance) {
        var sceModel = new SceModel();
        sceModel.rawJson = json;
        sceModel.model = json.model;
        sceModel.type = json.type;
        sceModel.objectId = json.objectId;
        sceModel.version = json.version;
        sceModel.properties = SceProperties_1.SceProperties.fromJson(json.properties, isInstance);
        if (isInstance) {
            return sceModel;
        }
        if (json.variables) {
            sceModel.variables = ComputeVariables_1.ComputeVariables.fromJson(json.variables);
            sceModel.variables.updateFunctionsFromComputeFunctionsJson(json.properties.functions);
        }
        else {
            sceModel.variables = ComputeVariables_1.ComputeVariables.initFromFunctions(json.properties.functions);
        }
        // Commenting this line as from now on the outpus/conditions in variables will be already part of sce-json (coming from UI)
        // sceModel.variables.updateConditionsFromComputeFunctions(sceModel.properties.functions);
        return sceModel;
    };
    SceModel.createSceModelsFromTypeReg = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var typeIdList, types, objectIdsPromises, objectIds, objectTypeVersions, versions, deviceTypeModel, deviceTypeVersion, mappingModel;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        typeIdList = [];
                        typeIdList.push(ModelConstants_1.ModelConstants.AssetCriticalitySceModelTypeATypeId);
                        typeIdList.push(ModelConstants_1.ModelConstants.AssetCriticalitySceModelTypeBTypeId);
                        typeIdList.push(ModelConstants_1.ModelConstants.AssetCriticalitySceModelTypeCTypeId);
                        typeIdList.push(ModelConstants_1.ModelConstants.AssetCriticalitySceModelTypeDTypeId);
                        types = new Types_1.Types();
                        objectIdsPromises = lodash_1.map(typeIdList, function (typeId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var sceModelType, sceModel, compressedModel, response;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, types.getLatestType(ModelConstants_1.ModelConstants.SceModel, typeId)];
                                    case 1:
                                        sceModelType = _a.sent();
                                        sceModel = SceModel.sceTypeToModel(sceModelType.data.content);
                                        compressedModel = SceCompressedModel_1.SceCompressedModel.createSceCompressedJson([sceModel], false);
                                        return [4 /*yield*/, compressedModel.saveCompressedModelToInfoModel()];
                                    case 2:
                                        response = _a.sent();
                                        return [2 /*return*/, response.data.objectId];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(objectIdsPromises)];
                    case 1:
                        objectIds = _a.sent();
                        return [4 /*yield*/, types.getTypeVersions(ModelConstants_1.ModelConstants.AssetCriticalityObjectTypeModel, ModelConstants_1.ModelConstants.AssetCriticalityObjectTypeTypeId)];
                    case 2:
                        objectTypeVersions = _a.sent();
                        versions = objectTypeVersions.data.versions;
                        deviceTypeModel = new DataItem_1.DataItem(Field_1.FIELD.MODEL, DataType_1.DataType.string);
                        deviceTypeModel.value = ModelConstants_1.ModelConstants.AssetCriticalityObjectTypeModel;
                        deviceTypeVersion = new DataItem_1.DataItem(Field_1.FIELD.VERSION, DataType_1.DataType.string);
                        deviceTypeVersion.value = "1.0.0";
                        return [4 /*yield*/, MappingModel_1.MappingModel.createNewMappingModel(ModelConstants_1.ModelConstants.AssetCriticalityObjectTypeTypeId, versions[versions.length - 1], deviceTypeModel, deviceTypeVersion)];
                    case 3:
                        mappingModel = _a.sent();
                        lodash_1.map(objectIds, function (objectId) {
                            mappingModel.properties.addType(objectId, "Published", ModelConstants_1.ModelConstants.AssetCriticalityModel);
                        });
                        return [4 /*yield*/, mappingModel.saveMappings()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**Clears all function type connections with object type */
    SceModel.clearConnections = function (sceModel, associatedObjectType) {
        var json = DeepCopy_1.deepCopy(sceModel);
        json.properties.associatedObjectType = associatedObjectType;
        var objectTypeGUID = Object.keys(json.properties.objectTypes)[0];
        json.properties.objectTypes = {};
        var sceFunctions = DeepCopy_1.deepCopy(json.properties.functions);
        lodash_1.map(Object.keys(sceFunctions), function (sceFunctionName) {
            var sceFunction = sceFunctions[sceFunctionName];
            sceFunctions[sceFunctionName] = ComputeFunction_1.ComputeFunction.clearConnections(sceFunction, objectTypeGUID);
        });
        json.properties.functions = sceFunctions;
        return json;
    };
    SceModel.updateConnections = function (sceModel, targetAssociatedObjectType) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var json, _a, sceFunctions, types, response, objectType, objectTypeGuids;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        json = DeepCopy_1.deepCopy(sceModel);
                        _a = json.properties;
                        return [4 /*yield*/, ModelBase_1.ModelBase.replaceType(targetAssociatedObjectType, json.properties.objectTypes)];
                    case 1:
                        _a.objectTypes = _b.sent();
                        json.properties.associatedObjectType = targetAssociatedObjectType;
                        sceFunctions = DeepCopy_1.deepCopy(json.properties.functions);
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.getTenantBasedTypeDetails(targetAssociatedObjectType.model.value, targetAssociatedObjectType.typeId.value, targetAssociatedObjectType.version.value)];
                    case 2:
                        response = _b.sent();
                        objectType = ObjectType_1.ObjectType.fromJson(response.data);
                        objectTypeGuids = Object.keys(json.properties.objectTypes);
                        lodash_1.map(Object.keys(sceFunctions), function (sceFunctionName) {
                            var sceFunction = sceFunctions[sceFunctionName];
                            sceFunctions[sceFunctionName] = ComputeFunction_1.ComputeFunction.updateConnections(sceFunction, objectTypeGuids, objectType);
                        });
                        json.properties.functions = sceFunctions;
                        return [2 /*return*/, json];
                }
            });
        });
    };
    SceModel.sceTypeToModel = function (json) {
        var sceModel = DeepCopy_1.deepCopy(json);
        delete sceModel[Field_1.FIELD.TYPEID];
        delete sceModel[Field_1.FIELD.VERSION];
        delete sceModel[Field_1.FIELD.ATTRIBUTES];
        delete sceModel[Field_1.FIELD.ISEXTENSIBLE];
        delete sceModel[Field_1.FIELD.NAME];
        delete sceModel[Field_1.FIELD.DESCRIPTION];
        sceModel[Field_1.FIELD.TYPE] = ModelConstants_1.ModelConstants.SceType;
        return sceModel;
    };
    SceModel.clearNonOverriddenConditions = function (sceModel) {
        lodash_1.map(Object.keys(sceModel.properties.functions), function (functionName) {
            var functionType = sceModel.properties.functions[functionName];
            if (functionType[Field_1.FIELD.ENDPOINT] !== undefined &&
                functionType[Field_1.FIELD.ENDPOINT][Field_1.FIELD.ISDIRTY] === false) {
                delete functionType[Field_1.FIELD.ENDPOINT];
            }
            else if (functionType[Field_1.FIELD.ENDPOINT] !== undefined) {
                delete functionType[Field_1.FIELD.ENDPOINT][Field_1.FIELD.ISDIRTY];
            }
            var conditions = functionType[Field_1.FIELD.INPUTS][Field_1.FIELD.CONDITIONS];
            if (conditions) {
                lodash_1.map(Object.keys(conditions), function (conditionName) {
                    var subConditions = conditions[conditionName][Field_1.FIELD.SUBCONDITIONS];
                    lodash_1.map(Object.keys(subConditions), function (subConditionName) {
                        var subCondition = subConditions[subConditionName];
                        lodash_1.map(Object.keys(subCondition), function (subConditionField) {
                            if (subCondition[subConditionField][Field_1.FIELD.ISDIRTY] === false) {
                                delete subCondition[subConditionField];
                            }
                            else {
                                delete subCondition[subConditionField][Field_1.FIELD.ISDIRTY];
                            }
                        });
                        if (lodash_1.isEmpty(subCondition)) {
                            delete subConditions[subConditionName];
                        }
                    });
                    if (lodash_1.isEmpty(subConditions)) {
                        delete conditions[conditionName][Field_1.FIELD.SUBCONDITIONS];
                    }
                    if (lodash_1.isEmpty(conditions[conditionName])) {
                        delete conditions[conditionName];
                    }
                });
                if (lodash_1.isEmpty(conditions)) {
                    delete functionType[Field_1.FIELD.INPUTS][Field_1.FIELD.CONDITIONS];
                }
            }
        });
        return sceModel;
    };
    /**
     * Pubilshes compute type model to Type Registry
     */
    SceModel.prototype.saveComputeModel = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var computeTypeJson, types, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        computeTypeJson = JSON.stringify(this.toComputeTypeJson());
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.saveType(computeTypeJson, this.properties.model.model.value)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    SceModel.prototype.saveSceModelAsDraft = function (sceModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var draftModel, draftType, draft, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        draftModel = ModelConstants_1.ModelConstants.ComputeDraftModel;
                        draftType = ModelConstants_1.ModelConstants.ComputeDraftType;
                        draft = Draft_1.Draft.createDraft(draftType, draftModel, sceModel.model, "1.0.0", JSON.stringify(sceModel));
                        draft.updateObjectId(uuid_1.v4());
                        return [4 /*yield*/, this._enggModelApi.StoreEnggModel(draft.toJson(), draft.objectId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    SceModel.prototype.updateDraftFromSceModel = function (sceModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var draftModel, draftType, draft, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        draftModel = ModelConstants_1.ModelConstants.ComputeDraftModel;
                        draftType = ModelConstants_1.ModelConstants.ComputeDraftType;
                        draft = Draft_1.Draft.createDraft(draftType, draftModel, sceModel.model, "1.0.0", JSON.stringify(sceModel));
                        draft.updateObjectId(sceModel.objectId);
                        draft.updateVersion(sceModel.version);
                        return [4 /*yield*/, this._objectsApi
                                .deleteObject(sceModel.objectId, draftModel)
                                .catch(function (err) { })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._enggModelApi.UpdateEnggModel(draft.toJson(), draft.objectId)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    SceModel.prototype.deleteComputeModel = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, model, typeId, types;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.properties.model, model = _a.model, typeId = _a.typeId;
                        if (!model || !typeId || !model.value || !typeId.value) {
                            throw new Error("modelId or typeId cannot be undefined");
                        }
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.deleteType(typeId.value, model.value)];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    SceModel.prototype.toComputeTypeJson = function () {
        var json = Object.create(null);
        json = this.properties.toTypeJson();
        json[Field_1.FIELD.VARIABLES] = this.variables.toJson();
        return json;
    };
    SceModel.monitorInstances = function (instancesJsons, objectToSceModuleIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var jsons, instanceApi, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        jsons = lodash_1.map(instancesJsons, function (instanceJson) {
                            var objectId = instanceJson[Field_1.FIELD.OBJECTID];
                            var objectIdToSceModuleId = lodash_1.find(objectToSceModuleIds, function (keyValue) { return keyValue.key === objectId; });
                            if (!objectIdToSceModuleId) {
                                throw new Error("Sce Module Id not found for object Id " + objectId);
                            }
                            return {
                                Data: instanceJson,
                                sceModuleId: objectIdToSceModuleId.value,
                            };
                        });
                        instanceApi = new Instance_1.Instance();
                        return [4 /*yield*/, instanceApi.monitorMultilpleInstances(jsons)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    SceModel.updateInstances = function (instancesJsons, objectToSceModuleIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var jsons, instanceApi, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        jsons = lodash_1.map(instancesJsons, function (instanceJson) {
                            var objectId = instanceJson[Field_1.FIELD.OBJECTID];
                            var objectIdToSceModuleId = lodash_1.find(objectToSceModuleIds, function (keyValue) { return keyValue.key === objectId; });
                            if (!objectIdToSceModuleId) {
                                throw new Error("Sce Module Id not found for object Id " + objectId);
                            }
                            return {
                                Data: instanceJson,
                                sceModuleId: objectIdToSceModuleId.value,
                            };
                        });
                        instanceApi = new Instance_1.Instance();
                        return [4 /*yield*/, instanceApi.updateExistingInstances(jsons)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    SceModel.prototype.startMonitoringExistingInstance = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sceKeyValueData, sceNoAlarmData, isError, instance, cloneInstances, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sceKeyValueData = [];
                        sceNoAlarmData = [];
                        isError = false;
                        return [4 /*yield*/, this.toComputeInstanceJsons()];
                    case 1:
                        instance = (_a.sent())[0];
                        console.log("After startMonitoringExistingInstance", instance);
                        cloneInstances = lodash_1.cloneDeep([instance]);
                        cloneInstances.forEach(function (instanceData) {
                            var isIndexExist = sceKeyValueData.findIndex(function (x) { return x.key == instanceData.type; });
                            if (isIndexExist < 0)
                                sceKeyValueData.push({ key: instanceData.type, value: instanceData.properties });
                        });
                        console.log("Inside startMonitoringExistingInstance sceKeyValueData", sceKeyValueData);
                        try {
                            sceNoAlarmData = SceInstance_1.checkForEmptyAlarms(sceKeyValueData, sceNoAlarmData);
                        }
                        catch (e) {
                            console.log("Error :: ", e);
                            isError = true;
                        }
                        console.log("Inside startMonitoringExistingInstance sceNoAlarmData", sceNoAlarmData);
                        // Set Output if alarm is empty
                        try {
                            cloneInstances = SceInstance_1.setOutputForEmptyAlarms(cloneInstances, sceNoAlarmData);
                        }
                        catch (e) {
                            console.log("Error :: ", e);
                            isError = true;
                        }
                        console.log("Inside startMonitoringExistingInstance cloneInstances", cloneInstances);
                        return [4 /*yield*/, this.monitorExistingInstance(isError ? instance : cloneInstances[0])];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.details];
                }
            });
        });
    };
    /**
     * Deletes version of rawJson
     */
    SceModel.prototype.renewRawJson = function () {
        var clone = DeepCopy_1.deepCopy(this.rawJson);
        delete clone[Field_1.FIELD.VERSION];
        this.rawJson = clone;
        this.version = 0;
    };
    SceModel.prototype.toComputeInstanceJsons = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var jsons, instanceJsons;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        jsons = lodash_1.map(this.properties.objectIds.value, function (objectId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.toComputeInstanceJson(objectId)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(jsons)];
                    case 1:
                        instanceJsons = _a.sent();
                        return [2 /*return*/, instanceJsons];
                }
            });
        });
    };
    SceModel.prototype.toComputeInstanceJson = function (objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var json, objects, instance, availableInstanceVersion;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        json = Object.create(null);
                        json = this.properties.toInstanceJson(objectId);
                        if (!this.version) return [3 /*break*/, 2];
                        objects = new Objects_1.Objects();
                        return [4 /*yield*/, objects.getObject(objectId, this.properties.model.model.value)];
                    case 1:
                        instance = _a.sent();
                        availableInstanceVersion = instance.data[Field_1.FIELD.VERSION];
                        json[Field_1.FIELD.VERSION] = availableInstanceVersion;
                        _a.label = 2;
                    case 2: return [2 /*return*/, json];
                }
            });
        });
    };
    SceModel.prototype.monitorExistingInstance = function (instance) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var instanceApi, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        instanceApi = new Instance_1.Instance();
                        return [4 /*yield*/, instanceApi.monitorExistingInstance(instance)];
                    case 1:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return SceModel;
}());
exports.SceModel = SceModel;
//# sourceMappingURL=SceModel.js.map